//793.706 x 1,122.52

/*{
    "id": "a4_page",
    "icon": "a4.svg",
    "text": "A4 21 x 29.7 cm",
    "size": {
        "height": 1170,
        "width": 827
    }
}*/

// "height": 1754,
//"width": 1240

//a4 => 1654 x 2339 pixels / pouces * 0.59

//appel cocart pour avoir les slug variations :
//https://affichemap.fr/wp-json/cocart/v1/products/5342/variations

export const pageSection = [
    {
        "id": "a4_page_num",
        "icon": "a4.svg",
        "text": "A4",
        "subtext" : "21 x 29.7 cm",
        "size": {
            "height": 1654,
            "width": 1170
        },
        "price" : "13",
        "attribute_support": "numerique-pdf",
		"attribute_format": "a4-21x29-7cm"
    },
    {
        "id": "a3_page_num",
        "icon": "a4.svg",
        "text": "A3",
        "subtext" : "29.7 x 42 cm",
        "size": {
            "height": 1654,
            "width": 1170
        },
        "price" : "13",
        "attribute_support": "numerique-pdf",
		"attribute_format": "a3-29-7x42cm"
    },
    {
        "id": "Instagram_Post",
        "icon": "fullscreen",
        "text": "Post Instagram",
        "size": {
            "height": 1080,
            "width": 1080
        },
        "price" : "13",
        "attribute_support": "numerique-pdf",
		"attribute_format": "personnalise"
    },
    {
        "id": "Facebook_Post",
        "icon": "fullscreen",
        "text": "Post Facebook",
        "size": {
            "height": 788,
            "width": 940
        },
        "price" : "13",
        "attribute_support": "numerique-pdf",
		"attribute_format": "personnalise"
    },
    {
        "id": "format_libre",
        "icon": "fullscreen",
        "text": "Format libre",
        "size": {
            "height": null,
            "width": null
        },
        "price" : "13",
        "attribute_support": "numerique-pdf",
		"attribute_format": "personnalise"
    }
]

export const pageSectionPrint = [
    {
        "id": "a4_page_print",
        "icon": "a4.svg",
        "text": "A4",        
        "subtext" : "21 x 29.7 cm",
        "size": {
            "height": 1654,
            "width": 1170
        },
        "price" : "19",
        "attribute_support": "impression",
		"attribute_format": "a4-21x29-7cm"
    },
    {
        "id": "a3_page_print",
        "icon": "a4.svg",
        "text": "A3",
        "subtext" : "29.7 x 42 cm",
        "size": {
            "height": 1654,
            "width": 1170
        },
        "price" : "30",
        "attribute_support": "impression",
		"attribute_format": "a3-29-7x42cm"
    },
    {
        "id": "a2_page_print",
        "icon": "a4.svg",
        "text": "A2",
        "subtext" : "42 x 59.4 cm",
        "size": {
            "height": 1654,
            "width": 1170
        },
        "price" : "39",
        "attribute_support": "impression",
		"attribute_format": "a2-42x59-4cm"
    },
]